import React from 'react'
import Sliders from '../components/Sliders'
import { Container, Col, Row } from 'react-bootstrap';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Link } from 'react-router-dom';
import About from '../assets/images/about-rmc-pro.png';


function Company() {
  return (
    <div>
         {/* <Slider /> */}
      <Sliders />
       {/* ========== About Us Section ========== */}
            <section className="entry pb-unset">
              <Container>
                <Row>
                  {/* Left Column: About Image */}
                  <Col md={5}>
                    <img 
                      src={About} 
                      alt="About Glazerocks RMC" 
                      className="img-fluid my-auto" 
                    />
                    <div className="info">
                      <h4><span>14</span> Years of Experience</h4>
                    </div>
                  </Col>
      
                  {/* Right Column: Text Content */}
                  <Col md={7}>
                    <h2>About Us</h2>
              <h3>We Are The Leader In Ready Mix Concrete Manufacturing</h3>
              <p>
               GlazeRocks RMC has been a trusted name in the ready mix concrete industry for over 14 years. We specialize in manufacturing and delivering high-quality ready mix concrete solutions that meet the evolving demands of modern construction projects.

With advanced automated batching plants and a well-maintained fleet of transit mixers, we ensure precision, consistency, and timely delivery for every project.<br></br> Our commitment to quality control, durable materials, and customer satisfaction has made us a preferred partner for residential, commercial, industrial, and infrastructure developments.

At Glazerocks RMC, we believe that strong foundations build strong futures.<br></br> Our expert technical team carefully monitors every stage — from raw material selection to final delivery — ensuring superior strength and reliability in every batch.

Glazerocks RMC — Strength You Can Build On.
              </p>
                  
                  </Col>
                </Row>
              </Container>
            </section>
      
    </div>
  )
}

export default Company